export default (str, find, replace) => {
  return str.split(find).join(replace)
}